import {Col, Row} from "react-bootstrap";
import * as React from "react";

import {WriteReviewButton} from "./writeReviewButton";

export const ZeroRatings = () => {
    return (
        <Row>
            <Col md={{span: 8, offset: 2}} className="p-3 text-center">
                <strong className="fs-4">This product hasn't been reviewed yet.</strong>
                <p>Help others make informed decisions by being the first to review this product!</p>
                <WriteReviewButton/>
            </Col>
        </Row>
    )
}